export const CHANGE_LOADER_STATUS = "CHANGE_LOADER_STATUS";
export const CHANGE_LOADER_TYPE = "CHANGE_LOADER_TYPE";
export const CHANGE_MODE = "CHANGE_MODE";
